import { Dataset } from '../../../types/types';
import { ExportSection } from '../types';

// Subset rows nest under the master idItem, so an id-less master must carry columns itself.
export const canExportSubsetsOnly = (
  isWithSubsetsMode: boolean,
  exportDataset: Dataset | undefined,
  sections: ExportSection[]
): boolean =>
  isWithSubsetsMode &&
  !!exportDataset?.idItem &&
  sections.some(
    (section) =>
      section.kind === 'subset' &&
      section.enabled &&
      section.columns.some((column) => column.selected)
  );
